import CountrySelect from "components/molecules/CountrySelect";
import { useCountriesStore } from "stores/countries";
import { FormProvider, useForm } from "react-hook-form";
import { useMemo } from "react";

// eslint-disable-next-line @typescript-eslint/ban-types
type CountrySelectContainerProps = {};

// eslint-disable-next-line unused-imports/no-unused-vars
const CountrySelectContainer = (props: CountrySelectContainerProps) => {
  const countries = useCountriesStore((state) => state.countries);
  const setCountryCode = useCountriesStore((state) => state.setCountryCode);

  const methods = useForm();

  const formValues = methods.watch();

  const handleSelect = (country: string) => {
    setCountryCode(country);
  };

  const filterCountries = useMemo(() => {
    if (formValues.country && countries) {
      return countries.filter((option) =>
        option.name.toLowerCase().includes(formValues.country.toLowerCase()),
      );
    }
    return countries;
  }, [formValues, countries]);

  return (
    <FormProvider {...methods}>
      <CountrySelect countries={filterCountries} onSelect={handleSelect} />
    </FormProvider>
  );
};

export default CountrySelectContainer;
